import {
  getBookingOnline,
  getBookingOnlineMedelementEmptySlots,
  getBookingOnlineEmptySchedule,
} from './handlers/getDoctorBookingOnlineData';
import { getDoctor, getDoctorWithEmptySchedule, getDoctorWithMedelementEmptySlots } from './handlers/getDoctorByAlias';
import { ids, doctorAliases } from './schedule';

export const widgetScheduleConfig = {
  ids,
  doctorAliases,
};

export const widgetScheduleHandlers = {
  getDoctor,
  getDoctorWithEmptySchedule,
  getDoctorWithMedelementEmptySlots,

  getBookingOnline,
  getBookingOnlineEmptySchedule,
  getBookingOnlineMedelementEmptySlots,
};
